// extracted by mini-css-extract-plugin
module.exports = {"input":"InputForm_input__i8xFF"};